export const AUTH_REQUEST = 'AUTH_REQUEST';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_ERROR = 'AUTH_ERROR';
export const SET_TOKEN_LOCALSTORAGE = 'SET_TOKEN_LOCALSTORAGE';
export const MFA_SUCCESS = 'MFA_SUCCESS';

export const AUTH_LOGOUT = 'AUTH_LOGOUT';
